/* CUSTOM_FREIGHTRATECACHE_BY_CLAUDE (ONYX 7348a6ea53cd, Ryan 2026-10-14)
   Settings -> Admin: Stored Freight Prices - the JS half. Markup in snippets/rep-settings-freight-rate-cache.liquid.
   GET/POST /admin/freight-rate-cache-config, GET /admin/freight-rate-cache (status),
   POST /admin/freight-rate-cache/fee-test. ("Try a price" moved to the Freight Hub calculator, H3 2026-10-15.) Loaded from the server first; Save stays disabled until it loaded, so a Save
   can never write a value the page did not read. */
(function () {
  'use strict';
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(n) { return n == null ? '-' : '$' + Number(n).toFixed(2); }
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) { if (el) el.className = 'rep-settings__message'; }
  var EXTRA_WORDS = { plain: 'Plain', liftGate: 'Lift gate', 'liftGate+residential': 'Residential + lift gate', residential: 'Residential (pair less lift gate)', insideDelivery: 'Inside delivery', limitedAccess: 'Limited access', deliveryAppointment: 'Delivery appointment', notify: 'Notify before delivery' };

  function feeRow(e) {
    var name = EXTRA_WORDS[e.set] || e.set;
    if (!e.learned) {
      var why = e.refused ? 'Rocket refused it' + (e.refusedWhy ? ' (' + esc(e.refusedWhy) + ')' : '') : 'not measured';
      return '<tr><td>' + esc(name) + '</td><td colspan="3" style="color: var(--rq-text-secondary);">' + why + '</td></tr>';
    }
    var fee = e.model === 'per-cwt' ? money(e.amount) + ' per 100 lb' + (e.minimum != null ? ' (min ' + money(e.minimum) + ')' : '') : money(e.amount) + ' flat';
    var range = e.min != null ? money(e.min) + ' to ' + money(e.max) : (e.derived ? 'worked out' : '');
    var fit = e.fitErrorPct != null ? e.fitErrorPct + '%' : '';
    return '<tr><td>' + esc(name) + '</td><td>' + fee + '</td><td>' + range + '</td><td>' + fit + '</td></tr>';
  }

  function renderStatus(box, d) {
    var t = d.table || {};
    var l = d.lookups || {};
    var ft = d.feeTest || {};
    var p = ft.progress || {};
    var html = '';
    if (!d.rocketApiConfigured) html += '<p style="color: var(--rq-danger, #e66);">Rocket\'s shipper API is not set up on the worker, so nothing can be priced.</p>';
    html += '<p><strong>Table:</strong> ' + (t.fresh || 0) + ' current, ' + (t.stale || 0) + ' too old, ' + (t.failed || 0) + ' failed, across ' + ((d.lanes && d.lanes.count) || 0) + ' routes.'
      + (d.backfill && !d.backfill.done ? ' Still counting routes from past deals (' + (d.backfill.scanned || 0) + ' deals read).' : '') + '</p>';
    html += '<p><strong>Extras test:</strong> ' + esc(ft.status || 'not started')
      + (p.total ? ' - ' + p.done + ' of ' + p.total + ' prices in' + (p.refused ? ', ' + p.refused + ' refused' : '') + (p.failed ? ', ' + p.failed + ' failed' : '') : '')
      + (ft.why ? ' (' + esc(ft.why) + ')' : '') + '</p>';
    var sched = d.feeSchedule && d.feeSchedule.schedule;
    if (sched) {
      var rows = Object.keys(sched).sort().map(function (k) { return feeRow(sched[k]); }).join('');
      html += '<table style="border-collapse: collapse; margin: 6px 0 10px; font-size: 13px;"><thead><tr><th style="text-align:left; padding-right: 14px;">Extra</th><th style="text-align:left; padding-right: 14px;">Adds</th><th style="text-align:left; padding-right: 14px;">Seen</th><th style="text-align:left;">Worst miss</th></tr></thead><tbody>' + rows + '</tbody></table>';
    }
    html += '<p><strong>Lookups:</strong> ' + (l.lookups || 0) + ' tried'
      + (l.hitRatePct != null ? ', ' + l.hitRatePct + '% answered from the table' : '')
      + (l.liveCalls ? ', live calls typically ' + Math.round((l.liveMedianMs || 0) / 1000) + ' s' : '') + '.</p>';
    if (d.lastTick && d.lastTick.startedAt) html += '<p style="color: var(--rq-text-secondary);">Last overnight pass: ' + esc(new Date(d.lastTick.startedAt).toLocaleString()) + '</p>';
    box.innerHTML = html;
  }

  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var api = window.RepPortal.API;
    var enabled = document.getElementById('settings-frc-enabled');
    var feeTest = document.getElementById('settings-frc-feetest');
    var perMinute = document.getElementById('settings-frc-perminute');
    var staleDays = document.getElementById('settings-frc-staledays');
    var markup = document.getElementById('settings-frc-markup');
    var save = document.getElementById('settings-frc-save');
    var show = document.getElementById('settings-frc-show');
    var restart = document.getElementById('settings-frc-restart');
    var msg = document.getElementById('settings-frc-msg');
    var status = document.getElementById('settings-frc-status');
    if (!save || !enabled) return;
    function apply(c) {
      enabled.checked = c.enabled === true;
      feeTest.checked = c.feeTest === true;
      perMinute.value = c.perMinute != null ? c.perMinute : 5;
      staleDays.value = c.staleDays != null ? c.staleDays : 7;
      markup.value = c.markupPct != null ? c.markupPct : 5;
    }
    (async function load() {
      try {
        var d = await api.get('/admin/freight-rate-cache-config');
        apply(d.config || {});
        save.disabled = false;
      } catch (e) {
        showMsg(msg, 'Could not load the current setting - reload before saving.', 'error');
      }
    })();
    save.addEventListener('click', async function () {
      hideMsg(msg);
      var body = { enabled: !!enabled.checked, feeTest: !!feeTest.checked, perMinute: Number(perMinute.value), staleDays: Number(staleDays.value), markupPct: Number(markup.value) };
      save.disabled = true;
      var orig = save.textContent;
      save.textContent = 'Saving...';
      try {
        var res = await api.post('/admin/freight-rate-cache-config', body);
        apply(res.config || {});
        showMsg(msg, res.meaning || 'Saved.', 'success');
      } catch (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      } finally { save.disabled = false; save.textContent = orig; }
    });
    show.addEventListener('click', async function () {
      status.textContent = 'Loading...';
      try { renderStatus(status, await api.get('/admin/freight-rate-cache')); }
      catch (e) { status.textContent = 'Could not load: ' + (e && e.message ? e.message : 'unknown error'); }
    });
    restart.addEventListener('click', async function () {
      if (!window.confirm('Run the extras price test again? It reprices about 120 loads over the next night it is switched on. The current schedule stays until the new test finishes.')) return;
      hideMsg(msg);
      try { var r = await api.post('/admin/freight-rate-cache/fee-test', { action: 'restart' }); showMsg(msg, r.note || 'Restarted.', 'success'); }
      catch (e) { showMsg(msg, 'Could not restart: ' + (e && e.message ? e.message : 'unknown error'), 'error'); }
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { renderStatus: renderStatus, feeRow: feeRow };
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_FREIGHTRATECACHE_BY_CLAUDE */
